module.exports = __webpack_public_path__ + "img/no-image.67edcff8.svg";